import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import AccessToken from '../../../hooks/token/AccessToken';
import { useRecoilValue } from 'recoil';
import { LoginInfoAtom } from '../../../recoil/LoginInfoAtom';
import Loading from '../../../components/common/Loading';
import { ShowErrorMsg } from '../../../utils/ShowErrorMsg';

const OrderDone = () => {

   const navigate = useNavigate();
   const [searchParams] = useSearchParams();
   const accessToken = AccessToken();

   const [loading, setLoading] = useState(true);
   const [orderedData, setOrderedData] = useState();

   const merchant_uid = searchParams.get('merchant_uid');

   // 유저 정보
   const LoginInfoAtomValue = useRecoilValue(LoginInfoAtom);

   useEffect(() => {
      if (!merchant_uid || !accessToken) return;

      // 결제가 됐는지 확인 (수량이 1개 일 때 2명이 동시에 구매하면 환불 되는 등의 경우 대비)
      const isComplete = async () => {
         try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/product/payment/complete`, {
               merchant_uid: merchant_uid
            }, {
               headers: {
                  Authorization: `Bearer ${accessToken}`
               }
            });
            setOrderedData(response.data.data)
         } catch (error) {
            console.error(error);
            navigate('/')
            ShowErrorMsg(error)
         } finally {
            setLoading(false);
         }
      };

      isComplete();
   }, [merchant_uid, accessToken]);

   if (merchant_uid === null) {
      alert('잘못된 접근입니다.')
      window.location.href = '/'
   }

   if (loading || !LoginInfoAtomValue) return <Loading />

   return (
      <div className="subpage order">
         <div className="routeBox">
            <div className="container">
               <div className="le-wrap">
                  <i className="icon"></i>
                  <p className="title">결제완료</p>
               </div>
               <div className="ri-wrap">
                  <p className="route-title">장바구니</p>
                  <i className="route-icon"></i>
                  <p className="route-title">주문/결제</p>
                  <i className="route-icon"></i>
                  <p className="route-title now">완료</p>
               </div>
            </div>
         </div>
         <section className="user-section">
            <div className="container">
               <div className="result-wrap">
                  <div className="result-inner">
                     <i className="icon green"></i>
                     <p className="result-title">
                        <span className="green">결제</span>가 완료되었습니다. 감사합니다.
                     </p>
                     {orderedData.type === 0 &&
                        <div className="sub-wrap">
                           <p className="sub">
                              마인드 인사이트는 심리검사 상품으로 구매 후 직접 사용하거나 마이페이지에서 선물하기가 가능합니다. <br />
                              자세한 내용은 <Link to="/mind-insight/mind-insight#anchor_6" className="link">자주 하는 질문</Link>을 확인해 주세요.
                           </p>
                        </div>
                     }
                  </div>
                  <div className="btn-wrap col-group">
                     <Link to="/" className="btn">메인 화면으로</Link>
                     {orderedData.type === 0 ? (
                        <Link
                           to={`${LoginInfoAtomValue.member_type === 0 ? '/my-page/general-user/code-use-gift' : '/my-page/counselor/code-send'}`}
                           className="btn green"
                        >
                           검사코드 사용하기
                        </Link>
                     ) : (
                        <Link
                           to='/my-page/purchase/history'
                           className="btn green"
                        >
                           구매내역 보기
                        </Link>
                     )}
                  </div>
               </div>
            </div>
         </section>
      </div>
   )
}

export default OrderDone